module.exports = __webpack_public_path__ + "static/img/xianyong.8d6b1dbd.png";